import { render, staticRenderFns } from "./applyed.vue?vue&type=template&id=23332f18&scoped=true&"
import script from "./applyed.vue?vue&type=script&lang=js&"
export * from "./applyed.vue?vue&type=script&lang=js&"
import style0 from "./applyed.vue?vue&type=style&index=0&id=23332f18&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "23332f18",
  null
  
)

export default component.exports